import {
  useAppSelector,
  useTriggerProductFilterOptionRecount,
} from "@/lib/redux/hooks";
import { ProductFilter } from "@/lib/redux/productFilters/productFiltersSlice";
import { productFilterSelectors } from "@/lib/redux/store";
import { forwardRef, useState } from "react";
import Dropdown, { GroupProps } from "./Dropdown/Dropdown";
import { Container } from "./styles";

export type AccordionProps = {
  groups: GroupProps[];
};

const Accordion = forwardRef<HTMLDivElement, AccordionProps>(
  function Accordion({ groups }) {
    const filterIds = useAppSelector((state) =>
      productFilterSelectors.selectIds(state)?.filter((id) => id !== "catalog")
    );
    const [activeFilter, setActiveFilter] = useState<ProductFilter | null>();
    const triggerRecount = useTriggerProductFilterOptionRecount();

    return (
      <Container>
        {filterIds.map((id) => (
          <Dropdown
            key={id}
            filterId={id}
            isOpen={activeFilter?.id === id}
            groups={groups}
            handleOpen={(filter) => {
              const nextState = filter.id === activeFilter?.id ? null : filter;
              setActiveFilter(nextState);
              if (nextState) triggerRecount(filter);
            }}
          />
        ))}
      </Container>
    );
  }
);

export default Accordion;
